// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_ENa","cls2":"LoswpPackPitch-cls2_LSQ LoswpPackPitch-cls1_ENa"};